export default {"src":"/_next/static/media/cointelegraph-dark.39323089.svg","height":74,"width":182,"blurWidth":0,"blurHeight":0};